<div class="pre-loader" *ngIf="!doneLoading"></div>
<div class="site-container">
    <header id="admin-header">
        <button type="button" class="btn btn-white btn-lg me-2 mobile-menu-button" (click)="showMobile = true"><i class="far fa-bars"></i></button>
        <a href="javascript:void(0)" routerLink="/manage" class="logo"><img src="images/PDX-logo.svg" alt="PDx logo" /></a>
        <div class="header-links">
            <a href="javascript:void(0)" (click)="logout()"><i class="far fa-power-off"></i> Logout</a>
        </div>
    </header>
    <nav id="admin-menu" [ngClass]="{'show': showMobile}">
        <button type="button" class="btn btn-white btn-lg border-0 mobile-menu-close" (click)="showMobile = false"><i class="far fa-times fa-lg"></i></button>
        <div class="user-welcome my-3">
            <div class="me-2" *ngIf="!currentUser.backgroundImage">
                <div class="avatar avatar-sm">{{currentUser.initials}}</div>
            </div>
            <div class="me-2" *ngIf="currentUser.backgroundImage">
                <div class="avatar avatar-sm" [ngStyle]="{'background-image': currentUser.backgroundImage}"></div>
            </div>
            <div>
                <p class="mb-1 text-medium">Hello, {{currentUser.firstName}}</p>
                <a href="javascript:void(0)" class="small" (click)="editMyProfile()">Edit My Profile</a>
            </div>
        </div>
        <ul class="list-unstyled site-nav">
            <li [ngClass]="{'active': currentMenu == 'dashboard'}"><a href="javascript:void(0)" routerLink="/manage/dashboard"><i class="icon far fa-tachometer-alt-fast"></i> <span class="menu-text"> Dashboard</span></a></li>
            <li [ngClass]="{'active': currentMenu == 'users'}"><a href="javascript:void(0)" routerLink="/manage/users"><i class="icon far fa-users"></i> <span class="menu-text"> Users</span></a></li>
            <li [ngClass]="{'active': currentMenu == 'orders'}"><a href="javascript:void(0)" routerLink="/manage/orders"><i class="icon far fa-store"></i> <span class="menu-text"> Orders</span></a></li>
            <li [ngClass]="{'active': currentMenu == 'users'}" *ngIf="false"><a href="javascript:void(0)"><i class="icon far fa-bell"></i> <span class="menu-text"> Notifications</span></a></li>
            <li [ngClass]="{'active': currentMenu == 'entities'}"><a href="javascript:void(0)" routerLink="/manage/entities"><i class="icon far fa-folder-tree"></i> <span class="menu-text"> Entity Management</span></a></li>
            <li [ngClass]="{'active': currentMenu == 'vendors'}"><a href="javascript:void(0)" routerLink="/manage/vendors"><i class="icon far fa-building"></i> <span class="menu-text"> Vendors</span></a></li>
            <li [ngClass]="{'active': currentMenu == 'users'}" *ngIf="false"><a href="javascript:void(0)"><i class="icon far fa-database"></i> <span class="menu-text"> System Log</span></a></li>
            <li [ngClass]="{'active': currentMenu == 'settings'}"><a href="javascript:void(0)" routerLink="/manage/settings"><i class="icon far fa-cog"></i> <span class="menu-text"> Settings</span></a></li>
        </ul>
    </nav>
    <div class="admin-page-content">
        <router-outlet>

        </router-outlet>
    </div>
</div>